<template>
    <div>
        <div class="content">
            <div class="header">
                <span>{{l10nDedicateADayOfLearning}}</span>
            </div>
            <div class="divider"></div>

            <form class="form" @submit.prevent="handleSubmit">
                <div class="step1">
                    <div class="step1-container">
                        <div class="step1-header">
                            <span>1. {{l10nChooseTheDayYouWantToSponsor}}</span>
                        </div>
                        <div class="step1-subheader">
                            <span>({{l10nYouCanAlsoChoose2Dates}})</span>
                        </div>
                        <div class="table-section">
                            <div>
                                <table class="choose-dates-table">
                                    <tr class="month-selector-row">
                                        <td v-bind:colspan="numOfColumns">
                                            <div class="month-selector-container">
                                                <div class="right-cal-nav" v-on:click="previousMonth()">
                                                    <font-awesome-icon :icon="['fal', 'chevron-left']"/>
                                                </div>
                                                <div class="month-year-info">
                                                    <span>{{gregorianYear}}</span>
                                                    <span>{{gregorianMonth}}</span>
                                                    <span>{{jewishMonth}}</span>
                                                </div>
                                                <div class="left-cal-nav" v-on:click="nextMonth()">
                                                    <font-awesome-icon :icon="['fal', 'chevron-right']"/>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr class="day-letters-row">
                                        <td v-for="n in numOfColumns">
                                            <span>{{numToHebrewLetter(numOfColumns - n + 1)}}</span>
                                        </td>
                                    </tr>
                                    <tr v-for="row in numOfRows">
                                        <td v-for="column in numOfColumns"
                                            v-on:click="toggleDate(computeDayOfMonth(row, numOfColumns - column + 1))"
                                            v-bind:class="{
                                                                    'enabled':computeDayOfMonth(row, numOfColumns - column + 1),
                                                                    'selected':isDateSelected(computeDayOfMonth(row, numOfColumns - column + 1))
                                                                }"
                                        >
                                            <span class="cell-contents">
                                                <span>{{computeDayOfMonth(row, numOfColumns - column + 1)}}</span>
                                                <span class="hebrew-day-of-month">
                                                    {{computeHebrewDate(computeDayOfMonth(row, numOfColumns - column + 1))}}
                                                </span>
                                            </span>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="dates.length > 0">
                    <div class="step2">
                        <div class="step2-container">
                            <div class="step2-header">
                                <span>2. {{l10nDedicationDetails}}</span>
                            </div>
                            <div v-for="(form, index) in formValues">
                                <div class="form-date-section">
                                    <div class="date-header">
                                        <span>{{form.date | formDateHeader}}</span>
                                        <span class="date-header-divider"></span>
                                        <span>{{form.date | formDateJewishHeader}}</span>
                                        <span v-if="index !== 0" class="copy-name-section">
                                            <label>
                                                <input type="checkbox" v-on:change="onCopyEvent($event, index)">
                                                <span>{{l10nCopyTheSameName}}</span>
                                            </label>
                                        </span>
                                    </div>
                                    <div class="row1">
                                        <div class="name-section">
                                            <div class="label-text">
                                                <span>{{l10nFullNameForTheDedication}}</span>
                                            </div>
                                            <div class="form-input-container">
                                                <input type="text" v-model="form.fullName">
                                            </div>
                                        </div>
                                        <div class="gender-section">
                                            <div class="radio-area">
                                                <div>
                                                    <label class="container">
                                                        <input type="radio" v-model="form.genderType"
                                                               :value="MALE">
                                                        <span class="label-text">בן</span>
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                                <div>
                                                    <label class="container">
                                                        <input type="radio" v-model="form.genderType"
                                                               :value="FEMALE">
                                                        <span class="label-text">בת</span>
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mothers-name-section">
                                            <div class="label-text">
                                                <span>{{l10nAndTheirMothersName}}</span>
                                            </div>
                                            <div class="form-input-container">
                                                <input type="text" v-model="form.motherName">
                                            </div>
                                        </div>
                                        <div class="reason-section">
                                            <div class="label-text">
                                                <span>{{l10nFor}}</span>
                                            </div>
                                            <jabra-dropdown :data="reasons" :initial-selected-item="ELOY_NISHMAS"
                                                            :mode="DEDICATION_REASON_MODE"
                                                            :ref="dropdownRefName"
                                                            v-on:jbr-select="setSelectedReason(form, $event)"></jabra-dropdown>
                                        </div>
                                    </div>
                                    <div class="row2">
                                        <div class="donor-name-section">
                                            <div class="label-text">
                                                <span>{{l10nNameOfDonor}}</span>
                                            </div>
                                            <div class="form-input-container">
                                                <input type="text" v-model="form.donorName">
                                            </div>
                                        </div>
                                        <div class="email-section">
                                            <div class="label-text">
                                                <span>{{l10nEmail}}</span>
                                            </div>
                                            <div class="form-input-container">
                                                <input type="text" v-model="form.email">
                                            </div>
                                        </div>
                                        <div class="telephone-section">
                                            <div class="label-text">
                                                <span>{{l10nTelephone}}</span>
                                            </div>
                                            <div class="form-input-container">
                                                <input type="text" v-model="form.telephone">
                                            </div>
                                        </div>
                                        <div class="country-section">
                                            <div class="label-text">
                                                <span>{{l10nCountry}}</span>
                                            </div>
                                            <div class="form-input-container last">
                                                <input type="text" v-model="form.country">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="form-action-section">
                        <jabra-btn dark :type="'submit'">
                            <span class="form-submit">{{l10nGoToDonate}}</span>
                        </jabra-btn>
                    </div>
                </div>
            </form>
        </div>
        <div class="bottom-colored-section-container">
            <div class="bottom-colored-section">
            </div>
        </div>
    </div>

</template>

<script>
    import helpers from '../services/helpers'
    import hebcal from '../services/hebcal'
    import lodash from '../services/lodash'

    import {
        MALE,
        FEMALE,
        ELOY_NISHMAS,
        REFUAH_SHLAIMA,
        ZIVUG_HAGOON,
        HATZLACHA,
        DEDICATION_REASON_MODE,
    } from '../services/constants'

    export default {
        name: 'dedication-day-component',
        data: function () {
            return {
                dates: [],
                formValues: [],
                startOfMonth: null,
            }
        },
        computed: {
            MALE() {
                return MALE
            },
            FEMALE() {
                return FEMALE
            },
            ELOY_NISHMAS() {
                return ELOY_NISHMAS
            },
            DEDICATION_REASON_MODE() {
                return DEDICATION_REASON_MODE
            },
            numOfColumns() {
                return 7
            },
            numOfRows() {
                if (this.startOfMonth) {
                    const daysInMonth = helpers.daysInMonth(this.startOfMonth)
                    const numRows = daysInMonth / this.numOfColumns
                    return Math.ceil(numRows)
                }
                return null
            },
            monthNames() {
                return ["January", "February", "March", "April", "May", "June",
                    "July", "August", "September", "October", "November", "December"
                ];
            },
            reasons() {
                return [ELOY_NISHMAS, REFUAH_SHLAIMA, ZIVUG_HAGOON, HATZLACHA]
            },
            gregorianYear() {
                return this.startOfMonth.getFullYear()
            },
            gregorianMonth() {
                return this.monthNames[this.startOfMonth.getMonth()]
            },
            jewishMonth() {
                return new hebcal.hebcal.HDate(this.startOfMonth).getMonthName('h')
            },
            defaultGender() {
                return MALE
            },
            dropdownRefName() {
                return 'jbrDropdownRefs'
            },
            dateOfLessonFromRoute() {
                const lessonNumber = this.$route.query.number
                if (lessonNumber) {
                    const map = this.$store.state.dayLessonMap.data
                    if (map) {
                        const a = map.find(dayMapping => {
                            return dayMapping[1] === Number(lessonNumber)
                        })
                        if (a) {
                            return a[0]
                        }
                    }
                }
                return null
            },
            l10nDedicateADayOfLearning() {
                return this.l10nGetter('dedicate_a_day_of_learning')
            },
            l10nChooseTheDayYouWantToSponsor() {
                return this.l10nGetter('choose_the_day_you_want_to_sponsor')
            },
            l10nYouCanAlsoChoose2Dates() {
                return this.l10nGetter('you_can_also_choose_2_dates')
            },
            l10nDedicationDetails() {
                return this.l10nGetter('dedication_details')
            },
            l10nCopyTheSameName() {
                return this.l10nGetter('copy_the_same_name')
            },
            l10nFullNameForTheDedication() {
                return this.l10nGetter('full_name_for_the_dedication')
            },
            l10nAndTheirMothersName() {
                return this.l10nGetter('and_their_mothers_name')
            },
            l10nFor() {
                return this.l10nGetter('for')
            },
            l10nNameOfDonor() {
                return this.l10nGetter('name_of_donor')
            },
            l10nCountry() {
                return this.l10nGetter('country')
            },
            l10nEmail() {
                return this.l10nGetter('email')
            },
            l10nTelephone() {
                return this.l10nGetter('telephone')
            },
            l10nGoToDonate() {
                return this.l10nGetter('go_to_donate')
            },


        },
        methods: {
            toggleDate(dayOfMonth) {
                if (dayOfMonth) {
                    const date = new Date(this.startOfMonth.getTime())
                    date.setDate(dayOfMonth)
                    const i = this.dates.map(date => {
                        return date.getTime()
                    }).indexOf(date.getTime())
                    if (i === -1) {
                        this.addDate(date)
                    } else {
                        this.dates.splice(i, 1)
                        this.formValues.splice(i, 1)
                    }

                    this.dates.sort(function sortEntries(dateA, dateB) {
                        if (dateA.getTime() < dateB.getTime()) {
                            return -1;
                        }
                        if (dateA.getTime() > dateB.getTime()) {
                            return 1;
                        }
                        // a must be equal to b
                        return 0;
                    })
                    // this.dates.sort()
                    this.formValues.sort(helpers.sortEntriesByFactory('date'))
                }
            },
            addDate(date) {
                this.dates.push(date)
                this.formValues.push({
                    date: date,
                    fullName: '',
                    genderType: this.defaultGender,
                    motherName: '',
                    reason: '',
                    donorName: '',
                    email: '',
                    telephone: '',
                    country: '',
                })
            },
            isDateSelected(dayOfMonth) {
                const date = new Date(this.startOfMonth.getTime())
                date.setDate(dayOfMonth)
                return this.dates.map(date => {
                    return date.getTime()
                }).indexOf(date.getTime()) > -1
            },
            computeDayOfMonth(rowNum, columnNum) {
                const startOffset = this.startOfMonth.getDay()
                const daysInMonth = helpers.daysInMonth(this.startOfMonth)
                const index = (rowNum - 1) * this.numOfColumns + columnNum - startOffset
                return index < 1 || index > daysInMonth ? null : index
            },
            computeHebrewDate(dayOfMonth) {
                if (dayOfMonth) {
                    const d = new Date(this.startOfMonth.getFullYear(), this.startOfMonth.getMonth(), dayOfMonth)
                    return helpers.numToHebrewLetter(new hebcal.hebcal.HDate(d).getDate())
                }
                return null
            },
            nextMonth() {
                this.resetDatesAndForm()
                if (this.startOfMonth.getMonth() === 11) {
                    this.startOfMonth = new Date(this.startOfMonth.getFullYear() + 1, 0);
                } else {
                    this.startOfMonth = new Date(this.startOfMonth.getFullYear(), this.startOfMonth.getMonth() + 1);
                }
            },
            previousMonth() {
                this.resetDatesAndForm()
                if (this.startOfMonth.getMonth() === 0) {
                    this.startOfMonth = new Date(this.startOfMonth.getFullYear() - 1, 11);
                } else {
                    this.startOfMonth = new Date(this.startOfMonth.getFullYear(), this.startOfMonth.getMonth() - 1);
                }
            },
            numToHebrewLetter(num) {
                return helpers.numToHebrewLetter(num)
            },
            handleSubmit() {
                console.log('mock submitted')
            },
            resetDatesAndForm() {
                this.dates = []
                this.formValues = []
            },
            setSelectedReason(obj, val) {
                obj.reason = val
            },
            onCopyEvent($event, index) {
                const isChecked = $event.target.checked
                if (isChecked) {
                    this.formValues.splice(index, 1, lodash.cloneDeep(this.formValues[0]))
                    this.$refs[this.dropdownRefName][index].selectItem(this.formValues[index].reason)
                }
            },
            l10nGetter(key) {
                return helpers.uiTextGetter(this.$store, key)
            },
        },
        created() {
            if (this.dateOfLessonFromRoute) {
                this.startOfMonth = new Date(this.dateOfLessonFromRoute.getFullYear(), this.dateOfLessonFromRoute.getMonth())
                this.addDate(this.dateOfLessonFromRoute)
            } else {
                const d = new Date()
                this.startOfMonth = new Date(d.getFullYear(), d.getMonth())
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../scss/main";

    .content {
        display: flex;
        flex-direction: column;
        align-items: center;
        max-width: 1600px;
        padding: 70px 0 220px;
        margin: 0 auto;
    }

    .header {
        text-transform: uppercase;
        @include font-abraham(50px, $font-color-blue, 400);
        margin: 0 0 20px 0;
    }

    .divider {
        width: 120px;
        height: 8px;
        margin: 30px;
        background: $accent-1;
    }

    .step1 {
        display: flex;
        justify-content: center;
        margin: 0 0 85px 0;
    }

    .step2 {
        display: flex;
        justify-content: center;
        margin: 0 3px 90px 0;
    }

    .step1-header, .step2-header {
        @include font-abraham(40px, $font-color-blue, 300);
    }

    .step1-subheader {
        @include font-abraham(28px, $font-color-blue, 300);
    }

    .form {
        margin: 42px 0 0 0;
        width: 100%;
    }

    .form-row {
        margin: 0 0 35px 0;
        padding: 0 30px;
    }

    .table-section {
        background: $accent-2-alpha;
        margin: 34px 0 0 0;
        padding: 37px;
    }

    table.choose-dates-table {
        border-collapse: collapse;
        border: $font-color-blue solid 1px;
        width: 100%;
        @include font-abraham(22px, $font-color-blue, 400);
        tr.month-selector-row {
            font-size: 34px;
            background: $accent-2;
            height: 80px;
        }
        tr.day-letters-row {
            td {
                border: none;
            }
        }
        td {
            padding: 0 20px;
            border: $font-color-blue solid 1px;
            text-align: center;
            line-height: 27px;

            .cell-contents {
                margin: 10px 0;
                display: flex;
                flex-direction: column;
            }
            .hebrew-day-of-month {
                font-size: 13px;
            }
            &.enabled {
                cursor: pointer;
                background: white;
                &:hover {
                    background: lighten($accent-1, 20%);
                    color: white;
                }
            }

            &.selected {
                background: $accent-1;
                @include font-abraham(22px, white, 500);
                &:hover {
                    background: lighten($accent-1, 10%);
                    color: white;
                }
            }
        }
    }

    .month-selector-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .month-year-info {
        flex-grow: 1;
        display: flex;
        justify-content: space-around;
    }

    .right-cal-nav {
        padding: 0 67px 0 20px;
    }

    .left-cal-nav {
        padding: 0 20px 0 67px;
    }

    .left-cal-nav,
    .right-cal-nav {
        cursor: pointer;
        display: flex;
    }

    .label-row {
        @include font-abraham(15px, $grey-1, 400);
        margin: 0 0 15px 0;
    }

    .input-row {
        input {
            @include font-abraham(30px, $grey-1, 300);
            line-height: 50px;
            width: 100%;
        }
    }

    .form-date-section {
        padding: 50px 0 0 0;
    }

    .form-action-section {
        display: flex;
        justify-content: center;
    }

    .date-header {
        @include font-abraham(28px, $font-color-blue, 400);
        .date-header-divider {
            margin: 5px;
        }
    }

    $lineheight: 54px;
    $label-height: 18px;
    .radio-area {
        display: flex;
        height: $lineheight;
        margin: $label-height 0 0 0;
        .container {
            display: block;
            position: relative;
            padding-left: 35px;
            margin: 12px;
            cursor: pointer;
            font-size: 22px;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
        }

        /* Hide the browser's default radio button */
        .container input {
            position: absolute;
            opacity: 0;
            cursor: pointer;
        }

        .label-text {
            @include font-abraham(24px, #aaaaaa, 300);
        }

        /* Create a custom radio button */
        .checkmark {
            position: absolute;
            top: 0;
            left: 0;
            height: 25px;
            width: 25px;
            border: #aaaaaa solid 1px;
            border-radius: 50%;
        }

        /* On mouse-over, add a grey background color */
        .container:hover input ~ .checkmark {
            background-color: white;
            border: $font-color-blue solid 1px;

        }

        /* When the radio button is checked*/
        .container input:checked ~ .checkmark {
            background-color: white;
            border: $font-color-blue solid 1px;
        }

        .container input:checked ~ .label-text {
            @include font-abraham(24px, $font-color-blue, 300);
        }

        /* Create the indicator (the dot/circle - hidden when not checked) */
        .checkmark:after {
            content: "";
            position: absolute;
            display: none;
        }

        /* Show the indicator (dot/circle) when checked */
        .container input:checked ~ .checkmark:after {
            display: block;
        }

        /* Style the indicator (dot/circle) */
        .container .checkmark:after {
            top: 4px;
            left: 4px;
            width: 17px;
            height: 17px;
            border-radius: 50%;
            background: $font-color-blue;
        }

        .flex-radio {
            display: flex;
        }
    }

    .row1, .row2 {
        display: flex;
        justify-content: space-between;
        margin: 35px 0 0 0;
    }

    .copy-name-section {
        @include font-abraham($label-height, $font-color-blue, 300);
        margin: 0 0 0 30px;
        input {
            margin: 0 10px 0 0;
        }

    }

    .donor-name-section, .email-section {
        flex-basis: 24%;
    }

    .label-text {
        @include font-abraham($label-height, $font-color-blue, 300);
    }

    .form-input-container {
        input {
            @include font-abraham(30px, $grey-2, 300);
            line-height: $lineheight;
            width: 100%;
            border: $grey-1 solid 1px;

        }
        &:not(.last) {
            padding: 0 17px 0 0;
        }
    }

    .form-submit {
        font-size: 20px;
        line-height: 50px;
        padding: 0 30px;
    }

    .bottom-colored-section-container {
        z-index: -1;
        position: relative;
    }

    .bottom-colored-section {
        background: rgb(220, 233, 239);
        height: 134px;
        width: 100%;
        position: absolute;
        bottom: 0;
    }

</style>
